import React, { useEffect, useState } from "react";
import EditButtonConfig from "../../../../components/EditComponents/EditButtonConfig";
import EditButtonGroup from "../../../../components/EditComponents/EditButtonGroup";
import EditField, { TableFieldAction } from "../../../../components/EditComponents/EditField";
import EditFormBlock from "../../../../components/EditComponents/EditFormBlock";
import EditHtmlContent from "../../../../components/EditComponents/EditHtmlContent";
import EditImageConfig from "../../../../components/EditComponents/EditImageConfig";
import EditLabel from "../../../../components/EditComponents/EditLabel";
import EditMailThread from "../../../../components/EditComponents/EditMailThread";
import EditSection from "../../../../components/EditComponents/EditSection";
import EditSpacer from "../../../../components/EditComponents/EditSpacer";
import EditTabView from "../../../../components/EditComponents/EditTabView";
import EditTableCell from "../../../../components/EditComponents/EditTableCell";
import EditTableviewSidebar from "../../../../components/EditComponents/EditTableviewSidebar";
import EditFileViewer from "../../../../components/EditComponents/EditFileViewer";
// import EditSeparator from "../../../../components/EditComponents/EditSeparator";
import EditProgressBar from "../../../../components/EditComponents/EditProgressBar";
import EditProgressTracker from "../../../../components/EditComponents/EditProgressTracker";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import BasicStyleEditor from "../../../../components/BuilderComponents/BasicStyleEditor";
import CustomCss from "../../../../components/BuilderComponents/CustomCss";
import EditReactComponent from "../../../../components/EditComponents/EditReactComponent";
import EditPositionedTab from "../../../../components/EditComponents/EditPositionedTab";

const EditDetailsviewFields = ({
  editElementRightsidebar,
  saveElement,
  smId,
  tableType = "statemachine",
  nestedGridData,
  device,
  appendExtraFilesAndFolders
}) => {
  const [editElementData, setEditElementData] = useState(null);

  const handleEditElementData = (type, data) => {
    setEditElementData({ ...editElementData, [type]: data });
  };
  const updateClassAndInlineStyle = (data) => {
    setEditElementData({ ...editElementData, className: data.classData, inline_style: data.inlineData });
  };

  useEffect(() => {
    if (
      !editElementData ||
      editElementData.type === "html" ||
      editElementData.type === "dynamic-html" ||
      editElementData.type === "form" ||
      editElementData.type === "button" ||
      editElementData.type === "dropdown"
    )
      return;
    saveElement(editElementData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editElementData]);
  useEffect(() => {
    setEditElementData(editElementRightsidebar.config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editElementRightsidebar.id]);
  const getEditElementComponent = () => {
    switch (editElementRightsidebar.type) {
      case "button":
      case "dropdown":
        return (
          <div className="edit_screen_fields button">
            <div style={{ width: "384px" }}>
              <EditButtonConfig
                editElementRightsidebar={editElementRightsidebar}
                onSave={saveElement}
                smId={smId}
                places="details_view"
                device={device}
                type={tableType}
              />
            </div>
          </div>
        );
      case "html":
      case "dynamic-html":
        return (
          <EditHtmlContent
            editElementData={editElementData}
            setEditElementData={saveElement}
            tableID={smId}
            places="details_view"
            element="button"
            device={device}
          />
        );
      case "image":
        return <EditImageConfig editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "label":
        return <EditLabel editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "field":
      case "variable":
        return (
          <EditField
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={smId}
            device={device}
          />
        );
      case "section":
      case "column":
      case "block":
        return <EditSection editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "spacer":
        return <EditSpacer editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "tableview":
        if (editElementRightsidebar.data) {
          return (
            <EditTableCell
              editElementData={editElementData}
              setEditElementData={setEditElementData}
              tableId={smId}
              data={editElementRightsidebar.data}
              elements={editElementRightsidebar.elements}
              device={device}
              appendExtraFilesAndFolders={appendExtraFilesAndFolders}
            />
          );
        }
        return <EditTableviewSidebar editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "mail_thread":
        return (
          <EditMailThread editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
        );
      case "tab":
        return <EditPositionedTab editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "file_viewer":
        return (
          <EditFileViewer editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
        );
      // case "separator":
      //   return (
      //     <EditSeparator editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
      //   );
      case "tabview":
        return (
          <EditTabView
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            nestedGridData={nestedGridData}
          />
        );
      case "button-group":
        return (
          <EditButtonGroup
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            elements={editElementRightsidebar.elements}
            smId={smId}
            device={device}
            places="details_view"
          />
        );
      case "form":
        return (
          <EditFormBlock
            editElementData={editElementData}
            setEditElementData={saveElement}
            device={device}
            elements={editElementRightsidebar.elements}
            tableID={smId}
            places="details_view"
            type={tableType}
          />
        );

      case "progress-bar":
        return (
          <EditProgressBar editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
        );

      case "progress-tracker":
        return (
          <EditProgressTracker
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={smId}
          />
        );

      case "custom-component":
        return (
          <EditReactComponent
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            save={saveElement}
          />
        );

      // case "variable":
      //   return <EditVariableType editElementData={editElementData} setEditElementData={saveElement} tableID={smId} />;
      default:
        return <div className="p_3">No field found</div>;
    }
  };

  const tabData = [
    {
      label: "Basic",
      content: (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ width: "382px" }}>
          {editElementData && getEditElementComponent()}
        </div>
      )
    },
    {
      label: "Style",
      content: (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ paddingTop: "0px" }}>
          <BasicStyleEditor
            value={{
              classData: editElementData?.className || {},
              inlineData: editElementData?.inline_style || {}
            }}
            callbackFunction={updateClassAndInlineStyle}
            fieldType={editElementData?.type || ""}
          />
        </div>
      )
    },
    {
      label: "Advanced",
      content: (
        <div style={{ overflow: "visible" }} className="form_basic_field_wrapper sidebar-edit-option-outer">
          <AdvanceEditForDetailviewField
            editElementData={editElementData}
            onChange={handleEditElementData}
            tableID={smId}
            device={device}
          />
        </div>
      )
    }
  ];
  const returnTypeBasedEditComponents = () => {
    const excludedTypes = [
      "button",
      "dropdown",
      "button-group",
      "html",
      "dynamic-html",
      "file_viewer",
      "spacer",
      "separator"
    ];

    if (excludedTypes.includes(editElementRightsidebar?.type)) {
      return (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ padding: "0px" }}>
          {editElementData && getEditElementComponent()}
        </div>
      );
    } else if (editElementRightsidebar?.data?.cell_type) {
      //sperate condition to not show tabs for tableview cell edit
      return (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ padding: "0px" }}>
          {editElementData && getEditElementComponent()}
        </div>
      );
    } else {
      return <BuilderTabs tabs={tabData} />;
    }
  };

  return (
    <div>
      {returnTypeBasedEditComponents()}
      {/* {(excludedTypes.includes(editElementData?.type) || editElementRightsidebar?.data?.cell_type) ? (
        <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ padding: "0px" }}>
          {editElementData && getEditElementComponent()}
        </div>
      )
        :
        <BuilderTabs tabs={tabData} />
      } */}
    </div>
  );
};

export default EditDetailsviewFields;

const AdvanceEditForDetailviewField = ({ editElementData, onChange, tableID, device }) => {
  return (
    <>
      {editElementData.type === "field" && (
        <TableFieldAction
          fieldConfig={editElementData}
          onChange={(data) => onChange("field_action", data)}
          tableID={tableID}
          device={device}
        />
      )}

      <CustomCss
        value={{
          custom_css: editElementData.custom_css || "",
          custom_id: editElementData.custom_id || "",
          custom_classname: editElementData.custom_classname || ""
        }}
        onChange={(e) => onChange(e.target.name, e.target.value)}
      />
    </>
  );
};

export { AdvanceEditForDetailviewField };
